import React, { useEffect } from 'react';

import { MainPageLayout } from 'layouts/MainPageLayout';

import { useAppDispatch } from 'store/store';
import { setReportAnIssueMode } from 'store/ticket-service/ticketSlice';

import { ReportAnIssue } from 'components/ReportAnIssue';

export const Support: React.FC = () => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(setReportAnIssueMode(true));
		return () => {
			dispatch(setReportAnIssueMode(false));
		};
	}, [dispatch]);

	return (
		<MainPageLayout>
			<ReportAnIssue />
		</MainPageLayout>
	);
};

